/** User-facing product name (UI copy only — URLs/domains unchanged). */
export const BRAND_NAME = "Sitewrap";

export const BRAND_ASSISTANT = `${BRAND_NAME} Assistant`;

/** Label shown when referring to CloudFormation stack output JSON in the UI. */
export const BRAND_SETTINGS_BUNDLE = "SitewrapSettingsBundle";

export const VERIFY_TXT_HOST_PREFIX = "_sitewrap-verify";
export const SITE_HEADER = "X-Sitewrap-Site";
export const ADMIN_SITE_STORAGE_KEY = "sitewrap_admin_site";
export const LEGACY_ADMIN_SITE_STORAGE_KEY = "crea_admin_site";

export function pageTitle(suffix?: string): string {
  if (!suffix?.trim()) return `${BRAND_NAME} Dashboard`;
  return `${BRAND_NAME} · ${suffix.trim()}`;
}
